import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import {Hero} from '@primer/react-brand'
import {Hero as HeroNext} from '@primer/react-brand-next'
import {isFeatureEnabled} from '@github-ui/feature-flags'

import type {GenericContent} from '../../../../brand/lib/types/contentful'

import {CtaGroup} from '../../_components/CtaGroup/CtaGroup'

type Props = {
  contentfulContent: GenericContent
}

export function HeroContent({ref, ...props}: Props & {ref?: React.Ref<HTMLDivElement>}) {
  const isPrimerBrandNextEnabled = isFeatureEnabled('primer_brand_next')
  const {contentfulContent} = props
  const {heading, subheading, ctas} = contentfulContent.fields

  return (
    <div ref={ref} className="lp-IntroHero">
      {isPrimerBrandNextEnabled ? (
        <HeroNext className="lp-IntroHero-hero" data-hpc align="center">
          {heading ? <HeroNext.Heading size="display">{heading}</HeroNext.Heading> : null}

          {subheading ? (
            <HeroNext.Description size="300" variant="default">
              {documentToPlainTextString(subheading)}
            </HeroNext.Description>
          ) : null}
        </HeroNext>
      ) : (
        <Hero className="lp-IntroHero-hero" data-hpc align="center">
          {heading ? <Hero.Heading size="1">{heading}</Hero.Heading> : null}

          {subheading ? <Hero.Description size="300">{documentToPlainTextString(subheading)}</Hero.Description> : null}
        </Hero>
      )}

      {ctas ? <CtaGroup contentfulContent={ctas} location="hero" /> : null}
    </div>
  )
}
